import { Badge, BadgeProps } from '@chakra-ui/react';
import { FC } from 'react';

interface ClassificationScoreBadgeProps {
  type: 'similarity' | 'containment';
  score: number;
  size?: BadgeProps['size'];
  precision?: number;
}

export const getScoreColor = (
  score: number,
  type: 'similarity' | 'containment' = 'similarity'
): string => {
  if (type === 'containment') {
    if (score >= 0.9) return 'green';
    if (score >= 0.8) return 'orange';

    return 'red';
  }

  if (score >= 0.94) return 'green';
  if (score >= 0.8) return 'yellow';
  if (score >= 0.6) return 'orange';

  return 'red';
};

export const ClassificationScoreBadge: FC<ClassificationScoreBadgeProps> = ({
  score,
  type,
  size = 'md',
  precision = 4,
}) => (
  <Badge
    colorScheme={getScoreColor(score, type)}
    fontSize="xs"
    fontWeight="medium"
    size={size}
  >
    {type === 'containment' && 'C: '} {(score * 100).toFixed(precision)}%
  </Badge>
);
